import {Component, Vue} from "vue-property-decorator"
import {
    getMarketCooperationConsultByMarketCooperationId,
    getMarketCooperationConsultDataExport,
    marketCooperationExportData,
    uploadFile
} from '@/api/common'
import {formatDate} from '@/utils/timeFilter'
import {Loading} from "element-ui"
import { menuBtn } from '@/utils/menu_level2_button'

@Component({
    filters: {
        dataFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val)))
    }
})
export default class ConsultRecord extends Vue {
    /* data */
    id: number | undefined
    tableData: any[] = []
    page = 1
    limit = 20
    total = 0
    exportBUttonDisabled = false

    /* created() */
    created() {
        const query = this.$route.query
        if (query.id) {
            this.id = Number(query.id)
            // this.name = query.name as string
            this.getTableData()
        }
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
    }

    /* methods */
    async getTableData() {
        const data: any = await getMarketCooperationConsultByMarketCooperationId({
            marketCooperationId: this.id as number,
            page: this.page,
            limit: this.limit
        })
        this.total = data.allNum
        this.tableData = data.marketCooperationConsultList.map((item: any) => ({...item, readonly: true}))

    }

    async uploadFile(row: any, e: any) {
        const loading = Loading.service({text: '正在上传文件'})
        const file = e.target.files[0]
        const formdata = new FormData()
        formdata.append('file', file, file.name)
        const data: any = await uploadFile(formdata)
        row.enclosureList.push({
            name: data.name,
            url: data.ossUrl
        })
        this.$nextTick(() => {
            loading.close()
        })
    }

    delFile(row: any, index: number) {
        row.splice(index, 1)
    }

    exportExcel() {
        this.exportBUttonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        getMarketCooperationConsultDataExport(
            {marketCooperationId: this.id as number,}).then(() => {
            this.exportBUttonDisabled = false
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }

    /*
   按钮权限验证
   */
    handleBtn(id: number) {
        return menuBtn(id)
    }
}
